export const CONTAINER_PHOTO_CATEGORIES = [
  'seal',
  'container',
  'batch_number',
  'full_bags',
  'empty_bags',
  'bag_marking',
  'production_temperature',
  'loading_temperature',
  'container_number',
  'other',
] as const;

export type ContainerPhotoCategory = (typeof CONTAINER_PHOTO_CATEGORIES)[number];

export interface ContainerPhotoItem {
  id: number;
  photoUrl: string;
  category: string;
}

export interface ExtractedImage {
  base64: string;
  contentType: string;
  name: string;
}

export interface CategoryPhotosGroup {
  category: string;
  label: string;
  images: ExtractedImage[];
}

const CATEGORY_LABELS: Record<string, string> = {
  seal: 'Seal Photo',
  container: 'Container Photo',
  batch_number: 'Batch Number',
  full_bags: 'Full Bags',
  empty_bags: 'Empty Bags',
  bag_marking: 'Bag Marking',
  production_temperature: 'Production Temperature',
  loading_temperature: 'Loading Temperature',
  container_number: 'Container Number',
  other: 'Other',
};

export function getCategoryLabel(category: string): string {
  return CATEGORY_LABELS[category] ?? category.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

const CATEGORY_SHORT_LABELS: Record<string, string> = {
  seal: 'Seal',
  container: 'Container',
  batch_number: 'Batch',
  full_bags: 'Full bags',
  empty_bags: 'Empty bags',
  bag_marking: 'Bag marking',
  production_temperature: 'Prod. temp.',
  loading_temperature: 'Load. temp.',
  container_number: 'Cont. #',
  other: 'Other',
};

export function getCategoryShortLabel(category: string): string {
  return CATEGORY_SHORT_LABELS[category] ?? getCategoryLabel(category);
}

export const CONTAINER_PHOTO_CATEGORY_ORDER: readonly string[] = CONTAINER_PHOTO_CATEGORIES;
